module.exports = __webpack_public_path__ + "img/aso.c15ab92d.png";